import React from 'react';
import { motion } from 'framer-motion';
import { heroPhotos } from '../data/heroPhotos';
export function Hero() {
  return <section className="relative h-screen min-h-[600px] flex items-center justify-center overflow-hidden pt-20 bg-brand-dark" data-id="element-257" data-mp="ej4mpv6y07ee">
      {/* Background photos */}
      <div className="absolute inset-0 z-0" data-id="element-258" data-mp="4lyxkshw2qgt">
        {/* Mobile: single portrait photo */}
        <img src={heroPhotos[2].src} alt={heroPhotos[2].alt} className="md:hidden w-full h-full object-cover object-top hero-photo-grade" data-id="element-259" data-mp="129h0hmovcycw" />
        {/* Tablet & desktop: vertical photo strip */}
        <div className="hidden md:grid grid-cols-3 lg:grid-cols-5 h-full gap-px" data-id="element-260" data-mp="sa9q98dflju0">
          {heroPhotos.map((photo, index) => <img key={photo.src} src={photo.src} alt={photo.alt} className={`w-full h-full object-cover object-top hero-photo-grade ${index > 2 ? 'hidden lg:block' : ''}`} data-id="element-261" data-mp="nbyh6zuyndcu" data-mpi={index} />)}
        </div>
        {/* Warm brand tint + darkening for text legibility */}
        <div className="absolute inset-0 bg-brand-brown/30 mix-blend-multiply" data-id="element-262" data-mp="3o7lqjmmw8ymu" />
        <div className="absolute inset-0 bg-brand-dark/35" data-id="element-263" data-mp="3o5j2371e3dk8" />
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-4xl mx-auto px-4 text-center text-white" data-id="element-264" data-mp="39cfmh57cz9w5">
        <motion.h1 initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        ease: 'easeOut'
      }} className="text-5xl md:text-7xl lg:text-8xl font-serif mb-6 leading-tight" data-id="element-265" data-mp="3e7uzjuxjl1ri">
          Елегантність у <br className="hidden md:block" data-id="element-266" data-mp="2vjzpal152635" /> кожній нитці
        </motion.h1>

        <motion.p initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.2,
        ease: 'easeOut'
      }} className="text-lg md:text-xl font-light mb-10 max-w-2xl mx-auto text-white/90" data-id="element-267" data-mp="2hinbaf5jgejw">
          Преміальний український жіночий одяг, створений для сучасної,
          витонченої жінки. Відкрийте для себе нашу нову колекцію позачасових
          речей.
        </motion.p>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.4,
        ease: 'easeOut'
      }} className="flex flex-col sm:flex-row items-center justify-center gap-4" data-id="element-268" data-mp="1b0vx1kt7peg5">
          <a href="#catalog" className="w-full sm:w-auto px-8 py-4 bg-brand-cream text-brand-dark rounded-full font-medium hover:bg-white transition-colors" data-id="element-269" data-mp="x37a87fl3x8g">
            Переглянути каталог
          </a>
          <a href="https://www.instagram.com/na.lilu" target="_blank" rel="noopener noreferrer" className="w-full sm:w-auto px-8 py-4 bg-transparent border border-white text-white rounded-full font-medium hover:bg-white/10 transition-colors" data-id="element-270" data-mp="1x9ul8c2qhfny">
            Стежити в Instagram
          </a>
        </motion.div>
      </div>
    </section>;
}